<template>
  <v-card flat color="transparent">
    <v-card-text class="py-0">
      <v-row class="ma-0 pa-0" align="center" style="height: 60px;">
        <v-col cols="12" class="pa-0 b-B">
          <v-toolbar flat color="transparent" height="40">
            <v-toolbar-title class="text-left subheading">
              <span class="title">{{ id == 'groups' ? '教室' : 'グループ' }}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="item == null && data && getPrivilegesLevel(data) <= 1" dark rounded depressed small color="error" @click.native="onAdd()">
                <span class="text-none">追加</span>
            </v-btn>
          </v-toolbar>
        </v-col>
      </v-row>
      <v-sheet class="overflow-y-auto" :style="contentsHeight">
        <v-row class="ma-0 pa-0" align="center">
          <v-col cols="1" class="pa-0" align="center"></v-col>
          <v-col cols="11" class="pa-0">
            <v-row class="ma-0 py-0" align="center">
              <v-col cols="12" class="py-0 b-B-GREY-DARK" align="center">
                <v-row align="center" justify="center" style="height:48px;">
                  <!-- <template v-for="(header, index) in heads[id]"> -->
                    <v-col :cols="header.width"  :align="header.align" class="pa-0" v-for="(header, index) in heads[id]" :key="header.key">
                      <template v-if="header.valid">
                        <v-sheet class="pa-0 customHeader" color="transparent">
                          <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                          <v-icon :color="heads[id][index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                        </v-sheet>
                      </template>
                      <template v-else>
                        <span>{{ header.title }}</span>
                      </template>
                    </v-col>
                  <!-- </template> -->
                  <v-col class="pa-0" align="center">
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="pa-0" align="center">
                <div class='overflow-y-auto'>
                  <RecycleScroller
                    class="scroller"
                    :items="myGroups"
                    :item-size="44"
                    key-field="key"
                  >
                    <template v-slot="{ item }">
                      <v-row class="ma-0 pa-0 customLine" align="center" style="height: 44px;" @click.stop="onSelect(item)">
                        <!-- <template v-for="(header) in heads[id]"> -->
                          <v-col :cols="header.width" class="pa-0" align="start" v-for="(header) in heads[id]" :key="header.key">
                            <template v-if="header.key == 'name'">
                              <v-row class="ma-0 pa-0" align="center">
                                <v-col cols="2" class="pa-0">
                                  <v-avatar size="30">
                                    <img v-if="item.avatar" :src="item.avatar.thumbnail">
                                    <v-avatar v-else size="30" :color="item.color"><span class="font-weight-bold white--text" style="font-size:20px; user-select: none;">{{ getNamePrefixFromItem(item) }}</span></v-avatar>
                                  </v-avatar>
                                  <v-avatar size="30" class="hidden-sm-and-down ml-2">
                                    <v-avatar size="30" :color="item.color"><span class="font-weight-bold white--text" style="font-size:20px; user-select: none;"></span></v-avatar>
                                  </v-avatar>
                                </v-col>
                                <v-col class="pa-0">
                                  <span class="overflow-text-hidden">{{ item[header.key] }}</span>
                                </v-col>
                              </v-row>
                            </template>
                            <template v-else-if="id == 'corps' && header.key == 'taskType'">
                              <v-chip x-small :color="item.task ? 'primary' : 'error'" class="px-1"><span>{{ item[header.key] }}</span></v-chip>
                            </template>
                            <template v-else-if="id == 'corps' && header.key == 'shareType'">
                              <v-chip x-small :color="item.chatsShare ? 'primary' : 'error'" class="px-1"><span>{{ item[header.key] }}</span></v-chip>
                            </template>
                            <template v-else-if="header.key == 'publicType'">
                              <v-chip x-small :color="item.public ? 'primary' : 'error'" class="px-1"><span>{{ item[header.key] }}</span></v-chip>
                            </template>
                            <template v-else-if="header.key == 'enableType'">
                              <v-chip x-small :color="item.enable ? 'primary' : 'error'" class="px-1"><span>{{ item[header.key] }}</span></v-chip>
                            </template>
                          </v-col>
                        <!-- </template> -->
                      </v-row>
                    </template>
                  </RecycleScroller>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>
    </v-card-text>

    <div>
      <v-dialog
        v-model="dialog"
        persistent
        width="800"
      >
        <v-card v-if="dialog">
          <template-group-profile
            :item="item"
            :dialog="dialog"
            :type="type"
            :school="school"
            @dismissed="onDismissed"
          >
          </template-group-profile>
        </v-card>
      </v-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-card>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import TemplateGroupProfile from './TemplateGroupProfile.vue'
Vue.component('template-group-profile', TemplateGroupProfile)
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      chatRef: 'chatRef/chatRef',
      windowSize: 'shared/windowSize'
    }),
    myGroups () {
      var temp = []
      var payload = null
      if (this.getPrivilegesLevel(this.data) <= 1) {
        for (var i in this.groups) {
          if (this.groups[i].schools[this.mySchool.key] && this.checkId(this.groups[i])) {
            payload = JSON.parse(JSON.stringify(this.groups[i]))
            temp.push(this.formItem(payload))
          }
        }
      } else {
        if (this.id === 'groups') {
          var keys = Object.keys(this.data.groups)
          for (i in keys) {
            if (this.data.groups[keys[i]]) {
              var index = this.groups.findIndex(g => g.key === keys[i])
              if (index !== -1 && this.checkId(this.groups[index])) {
                payload = JSON.parse(JSON.stringify(this.groups[index]))
                temp.push(this.formItem(payload))
              }
            }
          }
        } else {
          var groups = this.chatRef.filter(function (ref) {
            return ref.type === 'group'
          })
          for (i in groups) {
            index = this.groups.findIndex(g => g.key === groups[i].key)
            if (index !== -1 && this.checkId(this.groups[index])) {
              payload = JSON.parse(JSON.stringify(this.groups[index]))
              temp.push(this.formItem(payload))
            }
          }
        }
      }
      var key = null
      for (i in this.headers) {
        if (this.headers[i].value) {
          key = this.headers[i].key
          if (this.headers[i].value === 1) {
            temp.sort(function (a, b) {
              if (a[key] > b[key]) return -1
              if (a[key] < b[key]) return 1
              return 0
            })
          } else {
            temp.sort(function (a, b) {
              if (a[key] < b[key]) return -1
              if (a[key] > b[key]) return 1
              return 0
            })
          }
          break
        }
      }
      return temp
    },
    mySchool () {
      if (this.school) {
        return JSON.parse(JSON.stringify(this.school))
      } else {
        var keys = Object.keys(this.data.schools)
        for (var i in keys) {
          if (this.data.schools[keys[i]]) {
            var index = this.schools.findIndex(s => s.key === keys[i])
            if (index !== -1) {
              return JSON.parse(JSON.stringify(this.schools[index]))
            }
          }
        }
      }
      return null
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 40) + 'px;'
    },
    heads () {
      return { 'groups': this.headers, 'corps': this.headers2 }
    }
  },
  data () {
    return {
      dialog: false,
      headers: [
        { valid: true, over: false, value: 0, title: '名称', key: 'name', width: '8', align: 'start' },
        { valid: false, over: false, value: 0, title: '', key: '', width: '2', align: 'start' },
        { valid: false, over: false, value: 0, title: '伝言', key: 'publicType', width: '1', align: 'start' },
        { valid: false, over: false, value: 0, title: '状態', key: 'enableType', width: '1', align: 'start' }
      ],
      headers2: [
        { valid: true, over: false, value: 0, title: '名称', key: 'name', width: '8', align: 'start' },
        { valid: false, over: false, value: 0, title: 'タスク', key: 'taskType', width: '1', align: 'start' },
        { valid: false, over: false, value: 0, title: '他塾', key: 'shareType', width: '1', align: 'start' },
        { valid: false, over: false, value: 0, title: '伝言', key: 'publicType', width: '1', align: 'start' },
        { valid: false, over: false, value: 0, title: '状態', key: 'enableType', width: '1', align: 'start' }
      ],
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ],
      loading: false,
      item: null
    }
  },
  props: [ 'type', 'group', 'school', 'id' ],
  methods: {
    formItem (payload) {
      if (typeof payload.chatsShare === 'undefined') {
        Vue.set(payload, 'chatsShare', false)
      }
      if (typeof payload.color === 'undefined') {
        payload['color'] = '#1976D2FF'
      }
      if (typeof payload.task === 'undefined') {
        Vue.set(payload, 'task', false)
      }
      payload.taskType = payload.task ? '有効' : '無効'
      payload.shareType = payload.chatsShare ? '公開' : '非公開'
      payload.publicType = payload.public ? '公開' : '非公開'
      payload.enableType = payload.enable ? '有効' : '無効'
      return payload
    },
    checkId (item) {
      if (this.id === 'groups' && item.classroom) {
        return true
      }
      if (this.id === 'corps' && !item.classroom) {
        return true
      }
      return false
    },
    getNamePrefixFromItem (item) {
      var name = '？'
      if (item.name) {
        name = item.name.slice(0, 1)
      }
      return name
    },
    getSortIcon (item) {
      return this.sortIcons[this.heads[this.id][item].value]
    },
    onMouse (item, value) {
      this.heads[this.id][item].over = value
    },
    onSort (item) {
      var temp = this.heads[this.id][item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in this.headers) {
        this.heads[this.id][i].value = 0
      }
      this.heads[this.id][item].value = temp
    },
    onSelect (item) {
      this.item = JSON.parse(JSON.stringify(item))
      this.dialog = true
    },
    onAdd () {
      this.item = JSON.parse(JSON.stringify(this.$store.getters['groups/initial']))
      this.item.schools[this.school.key] = true
      this.item.classroom = (this.id === 'groups')
      this.item.createdAt = parseInt(new Date().getTime())
      this.dialog = true
    },
    onDismissed: function (result) {
      if (this.dialog) {
        this.dialog = false
      }
      this.item = null
    }
  }
}
</script>

<style scoped>
 .overflow-text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  user-select: none !important;
}

.b-B-GREY {
  border-bottom: 1px solid #EEEEEE80 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B-GREY-DARK {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.customHeader {
  cursor: pointer;
  line-height: 48px;
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}
</style>
